<template>
  <div class="chat-box">
    <div class="chat-header">
      <div>用户信息</div>
    </div>
    <div class="info-main-box" v-if="conversation.conversationID">
      <el-descriptions title="" :column="1">
        <el-descriptions-item label="用户名">
          <span class="primary-text" @click="toUser">
            {{ conversation.userProfile.nick }}
          </span>
        </el-descriptions-item>

        <el-descriptions-item label="来源平台">
          {{
            getNameByValue(platformList, conversation.platform) || ""
          }}</el-descriptions-item
        >
        <el-descriptions-item label="咨询模块">
          <el-tag size="small" v-if="entrySourceName">
            {{ entrySourceName || "" }}</el-tag
          >
        </el-descriptions-item>
        <el-descriptions-item label="教练" v-if="coach.id"
          ><span class="primary-text" @click="openCoach(coach)">{{
            coach.name || coach.real_name || "教练信息"
          }}</span></el-descriptions-item
        >
      </el-descriptions>
    </div>

    <coachInfo ref="coachRef" />
  </div>
</template>

<script>
import coachInfo from "./coach-info/index.vue";
import { getNameByValue } from "@/utils/utils.js";
import {
  platformList,
  entryList,
} from "../../../knowledgeManage/components/dict.js";
export default {
  props: {
    conversation: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    coachInfo,
  },
  data() {
    return {
      platformList,
      entryList,
      conversationName: "",
      entrySourceName: "",
      coach: {},
    };
  },
  watch: {
    conversation: {
      handler: function (conversation) {
      
        if (!conversation.conversationID) {
          return;
        }
        this.handlerInfo(conversation);
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {},

  methods: {
    toUser() {
      if (this.conversation.platform == 1) {
        this.$router.push({
          name: "userDetails",
          params: { id: this.conversation.toAccount },
        });
      }
    },
    openCoach(coach) {
      this.$refs.coachRef.open(coach);
    },
    handlerInfo(conversation) {
      this.entrySourceName =
        getNameByValue(this.entryList, conversation.entry_source) || "";
      if (
        conversation.entry_source == "coach" &&
        conversation.entry_target_id
      ) {
        this.$get("/user/coach/findById", {
          id: conversation.entry_target_id,
        }).then((res) => {
          this.coach = res.data.data;
        });
      } else {
        this.coach = {};
      }
    },
    getConversationName(conversation) {
     
      if (!conversation.type) {
        return;
      }

      if (conversation.type === "@TIM#SYSTEM") {
        return "系统通知";
      } else if (conversation.type === "C2C") {
        return (
          conversation.remark ||
          conversation.userProfile.nick ||
          conversation.userProfile.userID
        );
      } else if (conversation.type === "GROUP") {
        return (
          conversation.groupProfile.name || conversation.groupProfile.groupID
        );
      } else {
        return conversation.userProfile.name || "用户";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.chat-box {
  width: 100%;
  height: 100%;
}
.chat-header {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 20px;
  font-size: 15px;
  border-bottom: 1px solid #eee;
}
.primary-text {
  color: #409eff;
  cursor: pointer;
}
.info-main-box {
  padding-left: 14px;
  padding-top: 20px;
}
</style>